const reports = {
  getBaseLink(item) {
    let items = this.$route.path.split("/");
    let index = -1;
    if (items.filter(x => x == "training").length == 2) {
      index = items.lastIndexOf("training");
    } else if (items.filter(x => x == "surveys").length == 2) {
      index = items.lastIndexOf("surveys");
    } else {
      index = items.findIndex(x => x == "departments");
      if (index < 0) {
        index = items.findIndex(x => x == "members");
      }
      if (index < 0) {
        index = items.findIndex(x => x == "questions");
      }
      if (index < 0) {
        index = items.findIndex(x => x == "categories");
      }
      if (index < 0) {
        index = items.findIndex(x => x == "teams");
      }
    }

    if (index >= 0) {
      items = items.slice(0, index);
    }
    let url = items.join("/");

    if (url.indexOf("overall") >= 0 && item) {
      let replace = "";
      switch (item.featureId) {
        case this.$enums.features.SURVEYS:
          replace = "surveys";
          break;
        case this.$enums.features.RESOURCE:
          replace = "training";
          break;
        case this.$enums.features.PULSE:
          replace = "culture";
          break;
        case this.$enums.features.REVIEW:
          replace = "360-reviews";
          break;
        default:
          replace = "overall";
          break;
      }
      url = url.replace("overall", replace);
    }

    return url;
  },
  getLink(item) {
    let link = this.getBaseLink(item);
    if (item.team) {
      link += `/departments/${item.team.id}`;
    } else if (item.manager) {
      link += `/teams/${item.manager.id}`;
    } else if (item.category) {
      link += `/members/${this.filter.userId}/categories/${item.category.id}`;
    } else if (item.question) {
      link += `/members/${this.filter.userId}/questions/${item.question.id}`;
    } else if (item.user) {
      link += `/members/${item.user.id}`;
    } else if (this.filter.userId) {
      link += `/members/${this.filter.userId}`;
    }
    return link;
  },
  getCloseLink(ignoreMember) {
    let items = this.$route.path.split("/");
    let index = -1;
    if (items.filter(x => x == "training").length == 2) {
      index = items.lastIndexOf("training");
    } else if (items.filter(x => x == "surveys").length == 2) {
      index = items.lastIndexOf("surveys");
    } else {
      index = items.findIndex(x => x == "departments");
      if (index < 0 && !ignoreMember) {
        index = items.findIndex(x => x == "members");
      }
      if (index < 0) {
        index = items.findIndex(x => x == "questions");
      }
      if (index < 0) {
        index = items.findIndex(x => x == "categories");
      }
      if (index < 0) {
        index = items.findIndex(x => x == "teams");
      }
    }

    if (index >= 0) {
      items = items.slice(0, ignoreMember ? index : index + 1);
    }
    return items.join("/");
  },
  confidenceText(score) {
    if (score >= 80) {
      return "Score complete";
    } else if (score >= 60) {
      return "Score partially complete";
    }
    return "Score incomplete";
  },
  confidenceHelpText(score) {
    let text = `${this.$options.filters.no_decimal(
      score
    )}% of the data has been collected. `;
    if (score >= 80) {
      text += "You should feel confident in the accuracy of this data.";
    } else if (score >= 60) {
      text +=
        "There is still more data to collect, so please consider that before taking any action.";
    } else {
      text +=
        "We highly recommend waiting for more data to come in before taking action.";
    }
    return text;
  },
  getInitialTab() {
    let tab = 0;
    switch (this.$route.params.type) {
      case "departments":
        tab = 0;
        break;
      case "teams":
        tab = 1;
        break;
      case "members":
        tab = 2;
        break;
    }
    if (this.filter.managerId) {
      tab = 2;
    }
    if (this.filter.userId) {
      tab = 3;
    }
    if (this.filter.categoryId) {
      tab = 4;
    }
    if (this.$route.params.tab == "members") {
      tab = 2;
    }
    return tab;
  }
};

export default { methods: reports };
